/** @format */

import { Link } from "react-router-dom";
import { LI } from "../../../AbstractElements";
import { useDispatch } from "react-redux";
import {
  openView,
  openViewWithParams,
} from "../../../ReduxToolkit/Reducers/viewReducer";
export default function Transactions() {
  const dispatch = useDispatch();

  return (
    <LI className="" title="Transactions">
      <Link
        to={"#"}
        onClick={() =>
          dispatch(
            openViewWithParams({
              view: "reports_transactions",
              params: { backTo: null },
            })
          )
        }
      >
        <i className="fa fa-file-text" style={{ color: "white" }}></i>
      </Link>
    </LI>
  );
}
